module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d92e74438d72c2223692825df66e026e.svg";